module.exports = __webpack_public_path__ + "img/FUNDO_TITULO_313x442px.ae09596d.png";